import { paramDsName, paramXPath } from '../constants/parameterNames';
import { typeDataSource, typeXPath } from '../constants/parameterTypes';
import { getParamValue } from '../helpers/parameter.accessors';
import { getDataSource } from '../helpers/qRules.dataSource.helpers';
import { getValidNode } from '../helpers/qRules.node.helpers';
import { fromXml } from '../helpers/jsonXmlConvert';

const description =
    'Converts XML in one of the form’s data sources to a JSON string. Useful in combination with the MakeRequest command for interacting with JSON web APIs.';

const optionalParameters = [
    {
        name: paramXPath,
        description: 'XPath to the node to convert to JSON',
        type: typeXPath,
        dsParentName: paramDsName,
    },
    {
        name: paramDsName,
        description: 'Name of the data source with the node to convert to JSON',
        type: typeDataSource,
    },
];

function execute({ dataSources, parameters }) {
    const xpath = getParamValue(parameters, paramXPath);
    const dsname = getParamValue(parameters, paramDsName);
    const ds = getDataSource(dataSources, dsname);
    const node = xpath
        ? getValidNode(ds, xpath, `Could not find any node at ${xpath}`)
        : ds;
    const jsObj = fromXml(node.getNode());

    return JSON.stringify(jsObj);
}

const XmlToJson = {
    description,
    optionalParameters,
    execute,
};

export default XmlToJson;
